import * as jsxRuntime from "/Users/chenpintian/ComateProjects/Baidu/Personal-Website/baidu/personal-code/chenpintian-website/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment